export type NodeTestIdProp = {
    'data-testid': string;
};

export const getNodeTestIdProp = (id: string): NodeTestIdProp => ({
    'data-testid': id,
});
